import moment from 'moment'

const serverTimezone = '+07:00'

moment.locale('id')

moment.fn.formatShortDayAndTime = function () {
    const time = this.formatTime()

    return `${this.format(`D MMMM`)} pukul ${time}`
}

moment.fn.formatLongDayAndTime = function () {
    const time = this.formatTime()

    return `${this.format('D MMMM YYYY')} pukul ${time}`
}

moment.fn.formatDay = function () {
    return this.format('D MMMM YYYY')
}

moment.fn.formatTime = function () {
    const offset = this.format('Z')
    const offsetTranslation = {
        '+07:00': 'WIB',
        '+08:00': 'WITA',
        '+09:00': 'WIT',
    }
    const timezone = offsetTranslation[offset]

    return this.format(`HH:mm [${timezone}]`)
}

moment.fn.formatTimeWithoutTimezone = function () {
    return this.format('HH:mm')
}

export default moment

export const parseFromServer = dateTimeString => {
    return moment(`${dateTimeString} ${serverTimezone}`, 'YYYY-MM-DD HH:mm:ss Z')
}
